module.exports = __webpack_public_path__ + "img/profile-plus.5683436c.svg";